
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 18V9h2v9h-2zM9 12V7h1v5H9zM9 5v1h1V5H9zM8 18v-5h3v5H8zM12 8V5h7l2 3h-9z","fill":"#fff"}}),_c('path',{attrs:{"fill":"#000","d":"M0 0h26v26H0z"}}),_c('path',{attrs:{"d":"M14 20v-9h2v9h-2zM8 14V9h1v5H8zM8 7v1h1V7H8zM7 20v-5h3v5H7zM11 10V7h7l2 3h-9z","fill":"#fff"}})])
          )
        }
      }
    